import { render, staticRenderFns } from "./Spooky.vue?vue&type=template&id=b0a11366&scoped=true"
import script from "./Spooky.vue?vue&type=script&lang=js"
export * from "./Spooky.vue?vue&type=script&lang=js"
import style0 from "./Spooky.vue?vue&type=style&index=0&id=b0a11366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a11366",
  null
  
)

export default component.exports